import { usePageStore } from "@/store";

export const getAgent = async function(store) {
    let page =  usePageStore(this.$pinia)
    let { agentInfo } = this.listingDetail || {};
    if (this.originPriority && agentInfo) {
        store['updateAgentInfo'](agentInfo);
    } else {
        agentInfo = await page.getAgentInfo(this.agentId);
        store['updateAgentInfo'](agentInfo);
    }
};

export function asyncData(store) {
    let ps = [];
    let page =  usePageStore(this.$pinia)
    if (!page.companyInfo) {
        ps.push(page.getCompanyInfo());
    }
    ps.push(getAgent.call(this, store));
    return Promise.all(ps);
}
